/**
 * Created by aviranb on 05/11/2017.
 */
export const MODULE_DISTRIBUTION_APP = 'bt-app';
export const MODULE_XRAY_APP = 'xray.ui';



// WEBPACK FOOTER //
// ./constants/main.module.constants.js